import { LogoutOutlined } from '@ant-design/icons';
import { Flex, Select, Typography } from 'antd';
import logo from '../../assets/logo.png';
import UserProfile from '../UserProfile';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetState } from '../../store/auth';
import {
  selectToken,
  selectUserCountry,
  selectUserName,
} from '../../store/auth/selectors';

import {
  capitalizeWords,
  getDisplayRole,
  getRoleFromToken,
  isMobileScreenSize,
} from '../../utils/helpers';

import i18n from 'utils/i18n';
import testIds from 'utils/testId';

import { useAnalytics } from 'context/AnalyticsContext';
import { usePermissions } from 'context/PermissionsContext';
import { useEffect, useState } from 'react';
import { ROLE_GROUPS } from 'utils/constants';
import './Navbar.css';

const { Text } = Typography;

const Navbar = () => {
  const userCountry = useSelector(selectUserCountry);
  const role = getRoleFromToken(useSelector(selectToken));
  const analytics = useAnalytics();

  const userName = capitalizeWords(useSelector(selectUserName));
  const userRole = getDisplayRole(getRoleFromToken(useSelector(selectToken)));

  const { clearPermissions } = usePermissions();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.i18n.language);

  useEffect(() => {
    if (i18n.i18n.language == 'hi') {
      if (ROLE_GROUPS.ADMIN_AND_PM.includes(role)) {
        setSelectedLanguage('en');
        i18n.i18n.changeLanguage('en');
      } else {
        switch (userCountry) {
          case 'Indonesia':
            setSelectedLanguage('id');
            i18n.i18n.changeLanguage('id');
            break;
          case 'Vietnam':
            setSelectedLanguage('vi');
            i18n.i18n.changeLanguage('vi');
            break;
          case 'Test':
            setSelectedLanguage('en');
            i18n.i18n.changeLanguage('en');
            break;
        }
      }
    }
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(resetState());
    clearPermissions();
    analytics?.track?.('User Logout');
    navigate('/login');
  };

  const renderPopoverContent = () => (
    <Flex
      vertical
      align="center"
      style={{ width: '100px' }}
      className="text-center"
    >
      <Flex
        gap={8}
        role="button"
        onClick={handleLogout}
        data-testid={testIds?.navbar?.['btn-navbar-logout']}
      >
        <LogoutOutlined style={{ color: 'red', fontSize: '12px' }} />
        <Text type="danger">Logout</Text>
      </Flex>
    </Flex>
  );

  return (
    <div className="navbar-wrapper">
      <div className="cursor-pointer">
        <img
          className="logo-img cursor-pointer"
          src={logo}
          alt="Logo"
          data-testid={testIds?.navbar?.['img-navbar-rize_logo']}
        />
      </div>

      <div className="navbar-right-side">
        <Select
          label="Language"
          options={[
            {
              label: isMobileScreenSize ? 'EN' : 'English',
              value: 'en',
            },
            {
              label: isMobileScreenSize ? 'ID' : 'Indonesian',
              value: 'id',
            },
            {
              label: isMobileScreenSize ? 'VN' : 'Vietnamese',
              value: 'vi',
            },
          ]}
          value={selectedLanguage}
          onChange={(val) => {
            setSelectedLanguage(val);
            i18n.i18n.changeLanguage(val);
          }}
        />

        <UserProfile
          userName={userName}
          userRole={userRole}
          renderPopoverContent={renderPopoverContent}
        />
      </div>
    </div>
  );
};

export default Navbar;
